import React from 'react';
import { differentiators } from '../data/atlas';
export function DifferentiatorSection() {
  return <section className="bg-white px-4 py-6 sm:py-8" data-id="element-29" data-mp="3j4gzpmk4453s">
      <div className="mx-auto max-w-4xl" data-id="element-30" data-mp="3j24ijbm6hyrs">
        <h2 className="text-center text-2xl leading-none text-navy sm:text-3xl" data-id="element-31" data-mp="3558xslwkeivw">
          This isn’t just more dental content
        </h2>
        <p className="mt-1 text-center text-base font-extrabold uppercase tracking-wide text-teal sm:text-lg" data-id="element-32" data-mp="3a1pmbh7oez9i">
          It’s a complete visual study system.
        </p>

        <div className="mt-4 grid gap-x-6 gap-y-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-33" data-mp="306eg5nac30dd">
          {differentiators.map(item => <div key={item.title} className="flex gap-2.5" data-id="element-34" data-mp="2mfswvxgywoey">
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-35" data-mp="2qerzvcj52b3r">
                {item.emoji}
              </span>
              <div data-id="element-36" data-mp="2ch3fe5szh5z8">
                <h3 className="text-sm leading-tight text-navy sm:text-base" data-id="element-37" data-mp="2chv9tdaugxnx">
                  {item.title}
                </h3>
                <p className="text-sm font-medium leading-snug text-slate2" data-id="element-38" data-mp="15gvvgiab8owg">{item.body}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}